import { render } from "./SpondGroups.vue?vue&type=template&id=09ad4fd2"
import script from "./SpondGroups.vue?vue&type=script&lang=ts"
export * from "./SpondGroups.vue?vue&type=script&lang=ts"
script.render = render

export default script